<template>
  <div class="app-container">
    <BjPage ref="BjPage" :label-width="'80px'" :radio="false" :selection="selection" :query-params="queryParams" :col-span="colSpan" :get-action="queryApi" :serial="true" :before-reset-search="beforeResetSearch" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu" @afterFetchOriginalData="afterFetchOriginalData" @handleRadioChange="handleRadioChange">
      <template v-slot:baseForm>
        <!-- 发票编号 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.InvoicesNo')" prop="invoiceId">
            <BjInputNumber v-model="queryParams.invoiceId" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('billingPage.InvoicesNo')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <!-- 收费项名称 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.categoryName')" prop="billCategoryName">
            <BjInput v-model="queryParams.billCategoryName" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('billingPage.categoryName')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <!-- 时间选择 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.yearAndWeek')" prop="sku">
            <el-date-picker id="getWeekDate" v-model="weekDataNow" :picker-options="{ firstDayOfWeek: 1 }" style="width: 100%" type="week" format="yyyy-WW" :clearable="false" :placeholder="$t('billingPage.yearAndWeeks')" @change="handleQuery">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <!-- 公司名称 -->
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.companySeller')" prop="clientCode">
            <BjSelectLov v-model="queryParams.clientCode" :option-list="clientCodeList" :placeholder="$t('billingPage.companySeller')" @change="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.generateType')" prop="optType">
            <BjSelectLov v-model="queryParams.optType" lov-code="BILL_CHARGE_TYPE" @change="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.transactionNumber')" prop="transNo">
            <BjInput v-model="queryParams.transNo" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('billingPage.transactionNumber')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.PurchaseOrder')" prop="poId">
            <BjInput v-model="queryParams.poId" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('billingPage.PurchaseOrder')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.OrderNumber')" prop="orderId">
            <BjInput v-model="queryParams.orderId" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('billingPage.OrderNumber')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('billingPage.ReturnOrder')" prop="returnOrderId">
            <BjInput v-model="queryParams.returnOrderId" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('billingPage.ReturnOrder')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('CustomerFunction.common.logisticsNo')" prop="logisticsNumber">
            <BjInput v-model="queryParams.logisticsNumber" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('CustomerFunction.common.logisticsNo')" clearable @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
      </template>

      <template v-slot:tableOperation="tableOperationProp">
        <el-col>
          <el-button type="primary" class="main-btn" @click="onAdd">{{ $t('billingPage.create') }}</el-button>
          <el-button type="primary" class="delete-btn" :disabled="tableOperationProp.notSelected" @click="onDeleteSelected">{{ $t('bulkDelText') }}</el-button>
          <!-- <el-button type="primary" :disabled="!radioValue" @click="onGenerate">{{ $t('billingPage.generate') }}</el-button> -->
        </el-col>
      </template>
      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
            <template slot-scope="scope">
              <template v-if="false" />
              <template v-else-if="col.prop === 'transNo'">
                <span style="color: #3173d0;">{{ scope.row[col.prop] }}</span>
                <BjCopyIcon :copy="scope.row[col.prop]" />
              </template>
              <template v-else-if="col.prop === 'week'">{{ scope.row.year }}-{{ scope.row.week }}</template>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template slot-scope="props">
              <el-button type="text" class="edit-btn" @click="onEdit(props.row)">{{ $t('editText') }}</el-button>
              <el-button type="text" class="edit-btn" @click="onDetail(props.row)">{{ $t('detailsText') }}</el-button>
              <el-button type="text" class="delete-btn" @click="onDelete(props.row)">{{ $t('delText') }}</el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
    <DataForm ref="DataForm" @handleConfirm="handleConfirm" />
    <AddForm ref="AddForm" @handleConfirm="handleConfirmAdd" />

    <el-dialog :title="`${$t('editText')}${$t('billingPage.quantity')}`" :visible.sync="dialogFormVisible" width="400px">
      <el-form ref="form" :model="form">
        <el-form-item prop="quantity" :label="$t('billingPage.quantity')+':'" :rules="[
          { required: true, message: $t('inputText'), trigger: 'blur' }
        ]">
          <BjInputMoney v-model="form.quantity" style="width: 300px;" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="saveAmount()">{{ $t('okText') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import pageMiXin from '@/utils/page-mixin.js';
  import { billApi } from '@/api';
  import { reviewLocation } from '../invoiceReview/utils';
  import { OPTTYPE_LIST } from '@/utils/constants';
  import DataForm from './components/DataForm';
  import AddForm from './components/AddForm';
  export default {
    name: 'BusinessBillingTransactions',
    components: {DataForm, AddForm},
    mixins: [pageMiXin],
    data() {
      return {
        OPTTYPE_LIST,
        colSpan: 4,
        queryApi: billApi.getTransactionList,
        queryParams: {
          buyerName: null,
          status: null,
          invoiceId: null,
          billCategoryName: null,
          poId: null,
          orderId: null,
          returnOrderId: null,
          logisticsNumber: null,
        },
        labelList: [
          { label: this.$t('billingPage.transactionNumber'), prop: 'transNo', isCheck: true, disabled: false, width: 260 },
          { label: this.$t('billingPage.clientCode'), prop: 'clientCode', isCheck: true, disabled: false, width: 137 },
          { label: this.$t('billingPage.invoiceNumber'), prop: 'invoiceId', isCheck: true, disabled: false, width: 137 },
          { label: this.$t('billingPage.categoryName'), prop: 'name', isCheck: true, disabled: false, width: 128 },
          { label: this.$t('billingPage.Week'), prop: 'week', isCheck: true, disabled: false },
          // { label: this.$t('billingPage.Version'), prop: 'version', isCheck: true, disabled: false },
          { label: this.$t('billingPage.quantity'), prop: 'quantity', isCheck: true, disabled: false },
          { label: this.$t('billingPage.price'), prop: 'unitPrice', isCheck: true, disabled: false },
          { label: this.$t('billingPage.total'), prop: 'totalPrice', isCheck: true, disabled: false, width: 134 },
          // { label: this.$t('billingPage.createTime'), prop: 'gmtCreate', isCheck: true, disabled: false, width: 116},
          { label: this.$t('billingPage.generateType'), prop: 'optType', isCheck: true, disabled: false, width: 116 },
          { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 150 },
        ],
        weekDataNow: null,
        radioValue: '',
        // 下拉搜索列表
        clientCodeList: [],
        dialogFormVisible: false,
        form: {
          quantity: null,
          transNo: null
        }
      };
    },
    computed: {},
    watch: {
      'weekDataNow'() {
        if (this.weekDataNow !== null) {
          this.$nextTick(() => {
            this.queryParams.year = document.querySelector('#getWeekDate').value;
          });
        } else {
          this.queryParams.year = '';
        }
      },
    },
    mounted() {
      this.getClientInfoList();
    },
    methods: {
      onEdit(item) {
        if (item.invoiceReviewRequired) { this.$router.push(reviewLocation(item)); return; }
        this.form.transNo = item.transNo;
        this.form.quantity = item.quantity;
        this.dialogFormVisible = true;
      },
      saveAmount() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            billApi.updateTransaction(this.form).then(() => {
              this.dialogFormVisible = false;
              this.msgSuccess(this.$t('toast.operationSuccessText'));
              this.reFresh();
            });
          }
        });
      },
      // 获取所有客户信息列表
      getClientInfoList() {
        billApi.getClientInfoList().then(res => {
          res.data.forEach(item => {
            item.label = `${item.label} - ${item.value}`;
          });
          this.clientCodeList = res.data;
        });
      },
      handleRadioChange(row) {
        this.radioValue = row[0] ? row[0].clientCode : '';
      },
      afterFetchOriginalData(data) {
        this.$nextTick(() => {
          this.$refs.BjPage.tableData = data.content.map(item => {
            return { ...item.billCategory, ...item};
          });
        });
      },
      handleConfirm(row) {
        this.tableData.push(row);
        this.msgSuccess(this.$t('toast.operationSuccessText'));
        this.$refs.BjPage.tableData = this.tableData;
      },
      onDetail(item) {
        this.$refs.DataForm.drawer = true;
        this.$refs.DataForm.tableData = [item];
      },
      onGenerate() {
        billApi.geneTransTransaction({clientCode: this.radioValue}).then(() => {
          this.radioValue = '';
          this.msgSuccess(this.$t('toast.operationSuccessText'));
        });
      },
      // 新增 侧边栏
      onAdd() {
        this.$refs.AddForm.drawer = true;
        this.$refs.AddForm.openType = 'Add Transaction';
        this.$refs.AddForm.form = JSON.parse(JSON.stringify(this.queryParams));
        this.$refs.AddForm.getClientInfoList();
        if (this.queryParams.clientCode) {
          this.$refs.AddForm.getAllAdditionalCharges();
        }
      },
      /** 批量删除操作 循环删除 */
      onDeleteSelected() {
        if (this.selectedRows.some(row => row.invoiceReviewRequired)) { this.$message.warning(this.$t('invoiceReview.batchReview')); return; }
        if (!this.selectedRows.length) {
          this.$message.warning(this.$t('chooseText'));
          return;
        }
        const arr = [];
        this.selectedRows.forEach(item => {
          arr.push({'transNo': item.transNo});
        });
        this.$confirm(this.$t('toast.delAllTipText'), this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        })
          .then(() => {
            billApi.batchDelTransactionList(arr).then(res => {
              console.log(res, 'res');
              if (res.code == '200' || res._token || res.content || Array.isArray(res) || res.success === true) {
                this.msgSuccess(this.$t('toast.operationSuccessText'));
                this.reFresh();
              }
            });
          });
      },
      // 新增接口调用
      handleConfirmAdd(form) {
        billApi.addTransactionList(form).then(() => {
          this.$refs.AddForm.onCancel();
          this.msgSuccess(this.$t('toast.operationSuccessText'));
          this.reFresh();
        });
      },
      // 行内删除
      onDelete(row) {
        if (row.invoiceReviewRequired) { this.$router.push(reviewLocation(row)); return; }
        this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        })
          .then(() => {
            billApi.delTransactionList({transNo: row.transNo}).then(() => {
              this.msgSuccess(this.$t('toast.operationSuccessText'));
              this.reFresh();
            });
          })
          .catch(() => { });
      },
      beforeResetSearch() {
        this.queryParams.year = null;
        this.weekDataNow = null;
        this.radioValue = '';
        return new Promise(resolve => {
          resolve();
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
.el-icon-s-flag {
  float: right;
  line-height: 34px;
}
</style>
